import {ThunkAction} from 'redux-thunk';
import {IStore} from '../interface';
import {Action} from 'redux';
import {
  getSessions, removeSessionDialogue, removeTrainingDialogue
} from '../pageAsyncActions';
import {clearErrorAction, finishLoadingAction, startLoadingAction} from '../status/actions';
import {
  setSessions
} from './actions';
import {errorHandler} from '../errorHandler';
import {ToastKey} from '../../components/gritx-toast/ToastKeyEnum';
import {getSessionsApi} from '../api/sessions';
import {ITrainingDialogue} from '../trainings/interfaces';
import {removeDialogueApi} from '../api/dialogue';
import {loadTrainingDialoguesAction} from '../trainings/trainingsAsyncActions';

export const loadSessionsAction = (): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = getSessions;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      const {data} = await getSessionsApi();

      dispatch(finishLoadingAction(actionKey));
      dispatch(setSessions(data));
    } catch (e) {
      console.log('loadSessionsAction', e);
      dispatch(errorHandler({
        toastKey: ToastKey.LoadSessionsAction,
        actionKey,
        error: e
      }));
    }
  }
});

export const removeSessionDialogueAction = (dialogueId: number): ThunkAction<void, IStore, unknown, Action> => (async (dispatch, getState) => {
  const {
    auth: {auth0Client}
  } = getState();
  const isAuthenticated = await auth0Client.isAuthenticated();
  const actionKey = removeSessionDialogue;

  if (isAuthenticated) {
    dispatch(startLoadingAction(actionKey));
    dispatch(clearErrorAction(actionKey));
    try {
      await removeDialogueApi(dialogueId);
      dispatch(loadSessionsAction());
      dispatch(finishLoadingAction(actionKey));
    } catch (e) {
      console.log('removeSessionDialogueAction', e);
      dispatch(finishLoadingAction(actionKey));

      dispatch(errorHandler({
        toastKey: ToastKey.RemoveSessionDialogueAction,
        actionKey,
        error: e
      }));
    }
  }
});
